import React from 'react';
import { Link } from 'react-router-dom';
import './yuzu.css';

// Импорт изображений
import headerLogo from '../assets/MAIN/header_logo.png';
import yuzuBack from '../assets/yuzu/yuzu back.png';
import cityBack from '../assets/yuzu/Cityback.png';
import yuzuTitleBack from '../assets/yuzu/Yuzubac.png';
import clocks from '../assets/yuzu/clocks.png';
import screen from '../assets/yuzu/screen.png';
import screens from '../assets/yuzu/screens.png';
import leftImage from '../assets/yuzu/left.png';
import rightImage from '../assets/yuzu/right.png';
import clocks2 from '../assets/yuzu/clocks2.png';
import centerScreen from '../assets/yuzu/cerntrscreen.png';
import referrals from '../assets/yuzu/refererrals.png';
import xImage from '../assets/yuzu/x.png';
import shareImage from '../assets/yuzu/share.png';
import socialMedia from '../assets/yuzu/Social_media.png';
import preapp5 from '../assets/yuzu/Preapp_5.png';
import banner from '../assets/yuzu/banner.png';
import resumePDF from '../assets/MAIN/Dzhevelik_CV.pdf';

import Footer from './Footer';

function Yuzu() {
  // Функция скачивания резюме
  const downloadResume = () => {
    const link = document.createElement('a');
    link.href = resumePDF;
    link.download = 'Dzhevelik_CV.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="App yuzu-page">
      <main className="App-main">
        <div className="yuzu-content">
          {/* City Title */}
          <section className="yuzu-city-section" style={{backgroundImage: `url(${cityBack})`}}>
            <h1 className="yuzu-city-title">CITY</h1>
          </section>
        </div>

        {/* Clocks Image - Full Width */}
        <section className="yuzu-clocks-section">
          <img src={clocks} alt="Clocks" className="yuzu-clocks" />
        </section>

        <div className="yuzu-content" style={{backgroundImage: `url(${yuzuBack})`}}>
          {/* Yuzu Title */}
          <section className="yuzu-yuzu-section" style={{backgroundImage: `url(${yuzuTitleBack})`}}>
            <h1 className="yuzu-yuzu-title">YUZU</h1>
          </section>

          {/* Description Section */}
          <section className="yuzu-description-section">
            <div className="yuzu-description-content">
              <div className="yuzu-description-left">
                <h2 className="yuzu-description-title">DESCRIPTION</h2>
              </div>
              <div className="yuzu-description-right">
                <p className="yuzu-description-text selectable">
                  <span className="yuzu-highlight">YUZU is a gamified mini-app on TON blockchain where design addresses the challenge of creating an engaging and intuitive user experience in the crypto-mining space.
                <br /><br /></span>The interface is built on progressive disclosure principles and rewarding interaction patterns for sustainable long-term engagement.<span className="yuzu-highlight"> for sustainable long-term engagement.

                  </span>
                </p>
                <div className="yuzu-info-grid">
                  <div className="yuzu-info-column">
                    <div className="yuzu-info-header">CLIENT</div>
                    <div className="yuzu-info-value">YUZU CITY</div>
                  </div>
                  <div className="yuzu-info-column">
                    <div className="yuzu-info-header">MY ROLE</div>
                    <div className="yuzu-info-value">DESIGNER</div>
                  </div>
                  <div className="yuzu-info-column">
                    <div className="yuzu-info-header">DATE</div>
                    <div className="yuzu-info-value">MAR 2024</div>
                  </div>
                  <div className="yuzu-info-column">
                    <div className="yuzu-info-header">TIME</div>
                    <div className="yuzu-info-value">YEARS</div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Telegram Mini-App Title */}
          <section className="yuzu-telegram-section">
            <h1 className="yuzu-telegram-title">TELEGRAM MINI-APP</h1>
          </section>

          {/* Project Goals Section */}
          <section className="yuzu-goals-section">
            <div className="yuzu-goals-content">
              <div className="yuzu-goals-left">
                <h2 className="yuzu-goals-title">PROJECT GOALS</h2>
                <img src={screen} alt="Screen" className="yuzu-screen-image" />
              </div>
              <div className="yuzu-goals-right">
                <div className="yuzu-goal-item">
                  <p className="selectable">Thoughtful display of dual currencies, mining processes, task systems, and referral programs without creating visual chaos in the interface.</p>
                </div>
                <div className="yuzu-goal-item">
                  <p className="selectable">Gamified daily tasks and social elements build a habit of regularly returning to the app.</p>
                </div>
                <div className="yuzu-goal-item">
                  <p className="selectable">Visual class system and clear growth indicators should motivate users to continuously develop and improve their efficiency.</p>
                </div>
                <div className="yuzu-goal-item">
                  <p className="selectable">New users should instantly grasp the core app mechanics and know exactly where to start their YUZU journey.</p>
                </div>
              </div>
            </div>
          </section>

          {/* Node Interface Section */}
          <section className="yuzu-node-section">
            <div className="yuzu-node-content">
              <div className="yuzu-node-left">
                <h2 className="yuzu-node-title">NODE INTERFACE</h2>
                <p className="yuzu-node-text selectable">
                  Node interface uses visual hierarchy for KABOSU→YUZU resource flow with key efficiency metrics highlighted. Progressive disclosure handles paid upgrades without screen overload.<br /><br />Conversion banner leverages behavioral design – scarcity via timers and anchoring through alternative currency reduce microtransaction friction.
                </p>
                <div className="yuzu-node-columns">
                  <div className="yuzu-node-column">ENERGY SYSTEM</div>
                  <div className="yuzu-node-column">UPGRADE PATHS</div>
                  <div className="yuzu-node-column">CONVERSION DESIGN</div>
                </div>
              </div>
              <div className="yuzu-node-right">
                <img src={screens} alt="Screens" className="yuzu-screens-image" />
              </div>
            </div>
          </section>

          {/* Task System Section */}
          <section className="yuzu-task-section">
            <div className="yuzu-task-content">
              <div className="yuzu-task-left">
                <img src={leftImage} alt="Left" className="yuzu-task-image" />
              </div>
              <div className="yuzu-task-center">
                <div className="yuzu-task-item">TASK HIERARCHY</div>
                <div className="yuzu-task-item">DAILY REWARDS</div>
                <div className="yuzu-task-item">VISUAL FEEDBACK</div>
                <div className="yuzu-task-item">PROGRESS TRACKING</div>
              </div>
              <div className="yuzu-task-right">
                <img src={rightImage} alt="Right" className="yuzu-task-image" />
              </div>
            </div>
          </section>
        </div>

        {/* Clocks2 Image - Full Width */}
        <section className="yuzu-clocks2-section">
          <img src={clocks2} alt="Clocks2" className="yuzu-clocks2" />
        </section>

        <div className="yuzu-content" style={{backgroundImage: `url(${yuzuBack})`}}>
          {/* Referral Section */}
          <section className="yuzu-referral-section">
            <div className="yuzu-referral-content">
              <div className="yuzu-referral-left">
                <div className="yuzu-referral-features">
                  <div className="yuzu-referral-feature">CUSTOM ILLUSTRATIONS</div>
                  <div className="yuzu-referral-feature">COLLECTIBLE MECHANICS</div>
                  <div className="yuzu-referral-feature">UNLOCK PROGRESSION</div>
                  <div className="yuzu-referral-feature">ACHIEVEMENT CLARITY</div>
                </div>
              </div>
              <div className="yuzu-referral-center">
                <img src={centerScreen} alt="Center Screen" className="yuzu-center-screen" />
              </div>
              <div className="yuzu-referral-right">
                <h2 className="yuzu-referral-title">REFERRAL SYSTEM</h2>
                <p className="yuzu-referral-text selectable">
                  Social screen employs visual storytelling through unique hand-drawn YUZU City district cards, creating collectible mechanics that motivate friend invitations. Progressive content unlock enhances sense of achievement.
                </p>
                <p className="yuzu-referral-text selectable">
                  Referral interface balances friend progress display, personal rewards, and social goals through clear information hierarchy, minimizing cognitive load for sharing decisions.
                </p>
              </div>
            </div>
          </section>
        </div>

        {/* Referrals Image - Full Width */}
        <section className="yuzu-referrals-section">
          <img src={referrals} alt="Referrals" className="yuzu-referrals" />
        </section>

        <div className="yuzu-content" style={{backgroundImage: `url(${yuzuBack})`}}>
{/* Social Section */}
<section className="yuzu-social-section">
  <h1 className="yuzu-social-title">SOCIAL MEDIA</h1>
  <img src={socialMedia} alt="Social Media" className="yuzu-social-media-image" />
</section>

          {/* Pre-App Section */}
          <section className="yuzu-preapp-section">
            <div className="yuzu-preapp-content">
              <h1 className="yuzu-preapp-title">PRE-APP</h1>
              <div className="yuzu-preapp-main">
                <div className="yuzu-preapp-left">
                  <img src={preapp5} alt="Preapp 5" className="yuzu-preapp5-image" />
                </div>
                <div className="yuzu-preapp-right">
                  <h2 className="yuzu-preapp-story-title">PRE-APP SUCCESS STORY</h2>
                  <p className="yuzu-preapp-story-text selectable">
                    YUZU PRE-APP gained strong user love through gacha mechanics and viral sharing system where additional attempts were earned via friend invitations.
                  </p>
                  <p className="yuzu-preapp-story-text selectable">
                    The best elements were carried over to the main app, keeping users happy and engaged throughout the transition.
                  </p>
                  <div className="yuzu-data-integration">DATA-DRIVEN INTEGRATION</div>
                </div>
              </div>
            </div>
          </section>
        </div>

        {/* Banner Image - Full Width */}
        <section className="yuzu-banner-section">
          <img src={banner} alt="Banner" className="yuzu-banner" />
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default Yuzu;